import services from '../services'
import * as types from './mutation-types'

export const GetSuppressions = ({ commit }, params) => (
  services.listSuppressions(params).then(res => {
    commit(types.SET_SUPPRESSIONS, res.data)
  })
)

export const SaveSuppression = async ({ commit }, obj) => {
  return services.saveSuppression(obj).then(res => res)
}

export const DeleteSuppression = async ({ commit }, id) => {
  return services.deleteSuppression(id).then(res => res)
}

export const CheckSuppressions = async ({ commit }, emails) => {
  return services.checkSuppressions(emails).then(res => res.data)
}
